
import { ColorData, AgeTimeData, PracticalTreatment } from './types';

export const CORES_CROMOTERAPIA: ColorData[] = [
  {
    cor: "Vermelho",
    hex: "#ef4444",
    frequencia: "400-484 THz",
    onda: "620-750 nm",
    efeitos: "Ativação e Aceleração. No plano apométrico, é usado para cauterização energética e estímulo de vitalidade orgânica.",
    aplicabilidades: ["Paralisias", "Fraqueza nervosa", "Anemia", "Apatia", "Estímulo de órgãos debilitados", "Aceleração celular", "Cauterização energética"],
    contraindicacoes: ["Hipertensão", "Estados inflamatórios agudos", "Febre", "Crânio"],
    sinaisDesequilibrio: {
      excesso: ["Irritabilidade", "Febre", "Hiperatividade"],
      falta: ["Anemia", "Apatia", "Desânimo"]
    },
    combinacoes: ["Verde + Vermelho (Cauterização)", "Vermelho + Azul (Cauterização com Analgesia)"],
    palavrasChave: ["ativar", "acelerar", "estimular", "viva", "brilhante", "órgãos", "vitalidade", "cauterizar"]
  },
  {
    cor: "Rosa",
    hex: "#f472b6",
    frequencia: "Alta",
    onda: "Suave",
    efeitos: "Purificação e Ajuste Sanguíneo. Atua no ajuste da pressão e aceleração do fluxo dependendo da combinação.",
    aplicabilidades: ["Purificação do Sangue", "Pressão Alta (com Verde)", "Pressão Baixa (com Azul)", "Aceleração Sanguínea"],
    combinacoes: ["Verde + Rosa (Pressão Alta)", "Rosa + Azul (Pressão Baixa)", "Azul + Rosa (Aceleração e Dor)"],
    palavrasChave: ["sangue", "pressão alta", "pressão baixa", "circulação", "purificar", "desobstruir"]
  },
  {
    cor: "Laranja",
    hex: "#f97316",
    frequencia: "484-508 THz",
    onda: "590-620 nm",
    efeitos: "Circulação e Regeneração Óssea. Essencial para fraturas e eliminação de gorduras.",
    aplicabilidades: ["Fraturas e Fissuras", "Medula Óssea", "Fraqueza Muscular", "Eliminação de Gorduras", "Rigidez Articular"],
    contraindicacoes: ["Ansiedade aguda", "Insônia"],
    combinacoes: ["Verde + Laranja (Regeneração)", "Laranja + Amarelo (Vitalidade)"],
    palavrasChave: ["osso", "fratura", "medula", "gordura", "musculo", "trauma"]
  },
  {
    cor: "Amarelo",
    hex: "#eab308",
    frequencia: "508-526 THz",
    onda: "570-590 nm",
    efeitos: "Vitalidade e Fortalecimento. Tônico para tecidos sensíveis, nervos e músculos.",
    aplicabilidades: ["Debilidade Energética", "Fraqueza Mental", "Fortalecimento de Tecidos Sensíveis", "Regeneração Localizada"],
    contraindicacoes: ["Agitação mental", "Delírios"],
    combinacoes: ["Azul + Amarelo (Fortalecimento Local)"],
    palavrasChave: ["fortificar", "tecido sensivel", "nervos", "tonico", "calculo", "mente fraca"]
  },
  {
    cor: "Verde",
    hex: "#22c55e",
    frequencia: "526-606 THz",
    onda: "495-570 nm",
    efeitos: "Assepsia, Limpeza e Harmonização Celular. Anti-infeccioso potente e dilatador.",
    aplicabilidades: ["Regeneração Celular", "Assepsia Energética", "Pressão Alta (com Rosa)", "Lubrificação de Mucosas", "Cauterização"],
    contraindicacoes: ["Apatia profunda"],
    combinacoes: ["Verde + Azul (Harmonização Celular)", "Verde + Rosa (Pressão Alta)"],
    palavrasChave: ["limpeza", "assepsia", "infecção", "inflamação", "osso grande", "barreira", "isolar", "proteção"]
  },
  {
    cor: "Azul",
    hex: "#3b82f6",
    frequencia: "606-668 THz",
    onda: "450-495 nm",
    efeitos: "Equilíbrio, Sedação e Fixação. Analgésico e nutrificante de articulações e mucosas.",
    aplicabilidades: ["Alívio de Dor", "Pressão Baixa (com Rosa)", "Regeneração Óssea", "Lubrificação de Mucosas", "Sedação"],
    contraindicacoes: ["Hipotensão", "Letargia"],
    combinacoes: ["Azul + Rosa (Pressão Baixa)", "Azul + Roxo (Trauma e Coagulação)"],
    palavrasChave: ["sedar", "acalmar", "fixar", "articulação", "digestivo", "analgesia", "paz"]
  },
  {
    cor: "Índigo",
    hex: "#4f46e5",
    frequencia: "668-744 THz",
    onda: "420-450 nm",
    efeitos: "Coagulação e Comando. Estancamento energético de ferimentos.",
    aplicabilidades: ["Coagulação", "Estancamento", "Ferimentos Abertos", "Comando Mental"],
    combinacoes: ["Índigo + Azul (Paz e Estancamento)"],
    palavrasChave: ["coagular", "estancar", "ferimento", "sangue", "hemorragia"]
  },
  {
    cor: "Violeta",
    hex: "#a855f7",
    frequencia: "744-789 THz",
    onda: "380-420 nm",
    efeitos: "Transmuta, Cauteriza e Coagula. Bactericida potente.",
    aplicabilidades: ["Regeneração Óssea", "Coagulação", "Miasmas e Parasitas", "Cauterização Profunda"],
    combinacoes: ["Violeta + Verde (Cortes)", "Violeta + Azul (Ossos e Coagulação)"],
    palavrasChave: ["miasmas", "parasitas", "transmuta", "cauteriza", "coagula", "osso"]
  }
];

export const TEMPOS_APLICACAO: AgeTimeData[] = [
  {
    min: 0,
    max: 0.5,
    tempoBase: "2 a 5 segundos", 
    frequencia: "2x por semana",
    consideracoes: "Bebês: Adaptação energética em curso. Cuidado extremo."
  },
  {
    min: 0.6,
    max: 2,
    tempoBase: "5 a 10 segundos",
    frequencia: "2x por semana",
    consideracoes: "Crianças pequenas: Formação integral do corpo ainda incompleta."
  },
  {
    min: 2,
    max: 12,
    tempoBase: "10 a 20 segundos",
    frequencia: "2x a 3x por semana",
    consideracoes: "Fase de crescimento: Ajuste celular em estabilização."
  },
  {
    min: 12,
    max: 120,
    tempoBase: "20 a 30 segundos", 
    frequencia: "Conforme grupo",
    consideracoes: "Adultos: Regiões cefálicas (5-15s), Sistemas (20-30s)."
  }
];

export const DISCLAIMER_TEXT = "IMPORTANTE: Prática complementar. Use a técnica de mentalização (varredura) para envolver todo o sistema/órgão.";

export const TRATAMENTOS_PRATICOS: PracticalTreatment[] = [
  {
    "Condição": "Cefaleia",
    "Cores Sugeridas": "Azul, Violeta",
    "Método/Aplicação": "Projeção frontal e pulsos, cromopuntura pontos da fronte",
    "Duração/Temporização": "5 a 15 segundos por cor",
    "Observações": "Região Cefálica: Não exceder tempo técnico para não sobrecarregar o encéfalo."
  },
  {
    "Condição": "Neuralgia",
    "Cores Sugeridas": "Azul, Violeta, Verde (se houver processo inflamatório)",
    "Método/Aplicação": "Projeção sobre o local da dor, cromopuntura",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Verificar se há inflamação para incluir Verde."
  },
  {
    "Condição": "Otalgia",
    "Cores Sugeridas": "Azul, Violeta",
    "Método/Aplicação": "Projeção na orelha, cromopuntura",
    "Duração/Temporização": "5 a 15 segundos por cor",
    "Observações": "Evitar pressão direta. Alternar cores com foco na varredura interna."
  },
  {
    "Condição": "Dor de Dente",
    "Cores Sugeridas": "Azul, Violeta",
    "Método/Aplicação": "Projeção na face, cromopuntura nos pontos da face",
    "Duração/Temporização": "5 a 15 segundos por cor",
    "Observações": "Sessões curtas e precisas. Focar na raiz do dente."
  },
  {
    "Condição": "Acne",
    "Cores Sugeridas": "Verde, Azul",
    "Método/Aplicação": "Projeção na área afetada, cromopuntura nos pontos do rosto",
    "Duração/Temporização": "5 a 15 segundos por cor",
    "Observações": "Verde para limpeza celular, Azul para sedar a inflamação cutânea."
  },
  {
    "Condição": "Herpes Zoster",
    "Cores Sugeridas": "Verde, Azul, Violeta",
    "Método/Aplicação": "Projeção sobre as lesões, cromopuntura nos pontos adjacentes",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Verde para regeneração, Azul para dor, Violeta para cauterização."
  },
  {
    "Condição": "Cicatrizes",
    "Cores Sugeridas": "Verde, Laranja",
    "Método/Aplicação": "Projeção sobre a cicatriz, cromopuntura",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Verde para regeneração, Laranja para flexibilidade do tecido."
  },
  {
    "Condição": "Queimaduras",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção suave, distância adequada (indução)",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul para sedar calor/dor, Verde para assepsia e regeneração."
  },
  {
    "Condição": "Contusões",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção sobre o local, cromopuntura",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul para reduzir inchaço, Verde para cicatrização interna."
  },
  {
    "Condição": "Luxações",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção sobre a área, cromopuntura",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Após realinhamento físico. Azul (dor) e Verde (recuperação)."
  },
  {
    "Condição": "Fraturas",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção distante sobre o gesso ou tala",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (dor), Verde (calcificação). Uso técnico via indução."
  },
  {
    "Condição": "Cistite",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção sobre a bexiga, cromopuntura pélvica",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul para inflamação, Verde para assepsia da mucosa."
  },
  {
    "Condição": "Hemorroidas",
    "Cores Sugeridas": "Azul, Verde, Amarelo (se houver atonia)",
    "Método/Aplicação": "Projeção na região anal, cromopuntura",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (inflamação), Verde (regeneração), Amarelo (fortalecimento muscular)."
  },
  {
    "Condição": "Prisão de Ventre",
    "Cores Sugeridas": "Laranja, Amarelo",
    "Método/Aplicação": "Projeção abdominal (sentido horário)",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Laranja para peristaltismo, Amarelo para vitalidade muscular."
  },
  {
    "Condição": "Diarreia",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção abdominal",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul para acalmar, Verde para regenerar a flora."
  },
  {
    "Condição": "Úlcera Gástrica",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção sobre o estômago",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (acidez), Verde (regeneração da parede gástrica)."
  },
  {
    "Condição": "Varizes",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção ao longo das veias",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul para inchaço, Verde para assepsia e tônus vascular."
  },
  {
    "Condição": "Reumatismo",
    "Cores Sugeridas": "Azul, Verde, Laranja (rigidez)",
    "Método/Aplicação": "Projeção nas articulações",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul/Verde (inflamação). Laranja (mobilidade). Nunca use Vermelho."
  },
  {
    "Condição": "Insônia",
    "Cores Sugeridas": "Azul, Violeta",
    "Método/Aplicação": "Projeção no plexo solar e frontal",
    "Duração/Temporização": "10 a 20 segundos por cor",
    "Observações": "Azul para serenidade, Violeta para transmutação da agitação mental."
  },
  {
    "Condição": "Ansiedade",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção no plexo solar e cardíaco",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (paz), Verde (equilíbrio vibratório)."
  },
  {
    "Condição": "Depressão",
    "Cores Sugeridas": "Laranja, Amarelo, Rosa",
    "Método/Aplicação": "Projeção no plexo solar e cardíaco",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Laranja (vitalidade), Amarelo (ânimo), Rosa (amor próprio)."
  },
  {
    "Condição": "Fobias",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção frontal e plexo solar",
    "Duração/Temporização": "15 a 25 segundos por cor",
    "Observações": "Equilíbrio emocional e mentalização de segurança."
  },
  {
    "Condição": "Estresse",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção no plexo solar e frontal",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (relaxamento), Verde (harmonização sistêmica)."
  },
  {
    "Condição": "Dores Generalizadas",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção nas áreas doloridas",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul para analgesia, Verde para regeneração."
  },
  {
    "Condição": "Febre",
    "Cores Sugeridas": "Azul",
    "Método/Aplicação": "Projeção no plexo solar e frontal",
    "Duração/Temporização": "15 a 30 segundos",
    "Observações": "Cor única para baixar a temperatura por sedação."
  },
  {
    "Condição": "Tosse",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção na garganta e peito",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (irritação), Verde (regeneração pulmonar)."
  },
  {
    "Condição": "Gripe/Resfriado",
    "Cores Sugeridas": "Verde, Azul, Amarelo (prostração)",
    "Método/Aplicação": "Projeção frontal, peito, plexo solar",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Verde (imunidade), Azul (sintomas), Amarelo (energia vital)."
  },
  {
    "Condição": "Enxaqueca",
    "Cores Sugeridas": "Azul, Índigo, Violeta",
    "Método/Aplicação": "Projeção frontal e têmporas",
    "Duração/Temporização": "5 a 15 segundos por cor",
    "Observações": "Região Cefálica: Tempos reduzidos para precisão mental."
  },
  {
    "Condição": "Asma",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção no peito, garganta, plexo solar",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (espasmo brônquico), Verde (regeneração alveolar)."
  },
  {
    "Condição": "Bronquite",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção no peito e garganta",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (inflamação), Verde (regeneração brônquica)."
  },
  {
    "Condição": "Sinusite",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção nos seios da face",
    "Duração/Temporização": "5 a 15 segundos por cor",
    "Observações": "Azul (inflamação local), Verde (assepsia dos seios)."
  },
  {
    "Condição": "Rinite Alérgica",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção nasal e frontal",
    "Duração/Temporização": "5 a 15 segundos por cor",
    "Observações": "Azul (calmante), Verde (equilíbrio das mucosas)."
  },
  {
    "Condição": "Artrite/Artrose",
    "Cores Sugeridas": "Azul, Verde, Laranja (mobilidade)",
    "Método/Aplicação": "Projeção nas articulações",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul/Verde (inflamação). Laranja com cautela para flexibilizar."
  },
  {
    "Condição": "Pressão Alta (Hipertensão)",
    "Cores Sugeridas": "Azul",
    "Método/Aplicação": "Projeção no plexo solar e cardíaco",
    "Duração/Temporização": "20 a 30 segundos",
    "Observações": "Cor sedativa. Mentalização de calma e expansão vascular."
  },
  {
    "Condição": "Pressão Baixa (Hipotensão)",
    "Cores Sugeridas": "Vermelho (moderado), Amarelo, Laranja",
    "Método/Aplicação": "Projeção no plexo solar e raiz",
    "Duração/Temporização": "15 a 25 segundos por cor",
    "Observações": "Estímulo vibratório para elevar a pressão sistêmica."
  },
  {
    "Condição": "Pós-operatório",
    "Cores Sugeridas": "Verde, Azul",
    "Método/Aplicação": "Projeção nas incisões (distante)",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Verde (cicatrização), Azul (inflamação e dor)."
  },
  {
    "Condição": "Psoríase",
    "Cores Sugeridas": "Verde, Azul, Violeta",
    "Método/Aplicação": "Projeção nas lesões cutâneas",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Verde (regeneração), Azul (coceira/inflamação), Violeta (transmutação)."
  },
  {
    "Condição": "Eczema",
    "Cores Sugeridas": "Verde, Azul",
    "Método/Aplicação": "Projeção nas áreas afetadas",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Verde (assepsia), Azul (alívio da irritação)."
  },
  {
    "Condição": "Menopausa",
    "Cores Sugeridas": "Verde, Azul, Laranja",
    "Método/Aplicação": "Projeção no plexo solar e ovários",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Equilíbrio hormonal e vitalidade."
  },
  {
    "Condição": "TPM",
    "Cores Sugeridas": "Azul, Verde, Rosa",
    "Método/Aplicação": "Projeção abdominal e plexo solar",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (irritação), Verde (equilíbrio), Rosa (amparo emocional)."
  },
  {
    "Condição": "Dismenorreia (Cólicas Menstruais)",
    "Cores Sugeridas": "Azul, Verde, Laranja",
    "Método/Aplicação": "Projeção no baixo ventre",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (analgesia), Verde (inflamação), Laranja (relaxamento uterino)."
  },
  {
    "Condição": "Amenorreia (Ausência de Menstruação)",
    "Cores Sugeridas": "Laranja, Vermelho (moderação)",
    "Método/Aplicação": "Projeção no baixo ventre, ovários",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Laranja (estimular), Vermelho (energizar a região)."
  },
  {
    "Condição": "Amigdalite",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção na garganta",
    "Duração/Temporização": "15 a 25 segundos por cor",
    "Observações": "Azul (dor/inflamação), Verde (limpeza linfática)."
  },
  {
    "Condição": "Faringite",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção na garganta",
    "Duração/Temporização": "15 a 25 segundos por cor",
    "Observações": "Azul (sedação), Verde (regeneração da mucosa)."
  },
  {
    "Condição": "Laringite",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção na garganta",
    "Duração/Temporização": "15 a 25 segundos por cor",
    "Observações": "Azul (sedação), Verde (regeneração da mucosa)."
  },
  {
    "Condição": "Vaginismo",
    "Cores Sugeridas": "Azul, Verde",
    "Método/Aplicação": "Projeção na região pélvica",
    "Duração/Temporização": "20 a 30 segundos por cor",
    "Observações": "Azul (relaxamento muscular), Verde (regeneração)."
  }
];
